import { Injectable, InjectionToken } from '@angular/core';
import { MainToolbarHeaderInfo } from '@se/platform';
import { CustomPageConfig } from '@se/models';
import { Observable, of } from 'rxjs';

export interface ICustomPageToolbar {
    config: CustomPageConfig;
    info1: MainToolbarHeaderInfo;
    info2: MainToolbarHeaderInfo;
}

export interface ICustomPageToolbarResolver {
    getToolbar(): Observable<ICustomPageToolbar>;
}

export const CustomPageToolbarResolver = new InjectionToken('CustomPageToolbarResolver');

@Injectable()
export class EmptyToolbarResolver implements ICustomPageToolbarResolver {
    getToolbar() {
        return of({
            config: new CustomPageConfig(null, null, null),
            info1: { mainDescription: '', secondaryDescription: '', infoList: [] },
            info2: { mainDescription: '', secondaryDescription: '', infoList: [] },
        });
    }
}
